import { Component, Input } from '@angular/core';
import { SlideshowService } from '../../slideshow.service';

@Component({
    selector: 'article',
    templateUrl: 'article.component.html'
})
export class PreviewArticleComponent {
    @Input('device') device;
    constructor(public slideshow: SlideshowService) {}
}